var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.data,
          columns: _vm.columns,
          "row-key": "id",
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t(col.label)) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "trail_id", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(props.row.trail_id) +
                          "\n\t\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "trail_title", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(props.row.trail_title) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _c("q-td", { key: "percent", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            props.row.percent
                              ? props.row.percent.toFixed(2) + "%"
                              : ""
                          ) +
                          "\n\t\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "result_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.getDateFormated(props.row.result_date)) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            attrs: {
                              small: "",
                              color: _vm.getColorStatus(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(_vm.getStatus(props.row.status))
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "trail_content_id", attrs: { props: props } },
                      [
                        props.row.trail_content_type !== "news"
                          ? [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    round: "",
                                    color: "secondary",
                                    icon: "far fa-file-edit"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showContents(props.row)
                                    }
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("contents")) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "q-td",
                      { key: "certificate_id", attrs: { props: props } },
                      [
                        props.row.status === 1
                          ? _c(
                              "q-btn",
                              {
                                attrs: {
                                  flat: "",
                                  round: "",
                                  color: "secondary",
                                  icon: "far fa-eye"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showCertificate(
                                      props.row.trail_id
                                    )
                                  }
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("view_certificate_tooltip")
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm.show_trail_contents
        ? _c("content-modal", {
            attrs: {
              show_trail_contents: _vm.show_trail_contents,
              trail_title: _vm.trail_title,
              trail_id: _vm.trail_id
            },
            on: {
              hide_report: function($event) {
                return _vm.hideReport()
              }
            }
          })
        : _vm._e(),
      _c("certificate", {
        attrs: { show: _vm.show_certificate, data: _vm.certificate_data },
        on: { hideCertificate: _vm.hideCertificate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }